import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MapboxComponent } from './mapbox/mapbox.component';

const routes: Routes = [
    {
        path: 'map',
        component: MapboxComponent
    },
    {
        path: 'map/:names',
        component: MapboxComponent
    },
    {
        path: '**',
        redirectTo: '/map',
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /app/src/app/app-routing.module.ts